import * as React from 'react';
import { IPanelActionsProps } from './types';
import {
    ASIDE_PANEL_ACTIONS_SECTION_TITLE_ACTIONS,
    AsidePanelActionsButtonsGroup,
    AsidePanelActionsSection
} from '../../../../index';
import './_PanelActions.scss';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';
import { EBoardTab } from '../../../types';
import {
    ASIDE_PANEL_ACTIONS_SECTION_TITLE_SETTINGS,
    CLASS_ASIDE_PANEL_ACTIONS_SCROLL
} from '../../../../asidePanel/components/AsidePanelActions/constants';
import { DeleteButtonHOC } from '../../../actions/hocs/DeleteButtonHOC/DeleteButtonHOC';
import { PrefixesPanelButtonHOC } from '../../../details/CardNumber/hocs/PrefixesPanelButtonHOC/PrefixesPanelButtonHOC';
import {
    EmailNotificationsPanelButtonHOC
} from '../../../details/Notifications/hocs/EmailNotificationsPanelButtonHOC/EmailNotificationsPanelButtonHOC';
import {
    PushNotificationsPanelButtonHOC
} from '../../../details/Notifications/hocs/PushNotificationsPanelButtonHOC/PushNotificationsPanelButtonHOC';
import { ColorsPanelButtonHOC } from '../../../details/Colors/hocs/ColorsPanelButtonHOC/ColorsPanelButtonHOC';
import { GanttPanelButtonHOC } from '../../../details/ShowOnGantt/hocs/GanttPanelButtonHOC/GanttPanelButtonHOC';
import {
    LinksToCardsPanelButtonHOC
} from '../../../details/LinksToCards/hocs/LinksToCardsPanelButtonHOC/LinksToCardsPanelButtonHOC';
import { TimeZonePanelButtonHOC } from '../../../details/TimeZone/hocs/TimeZonePanelButtonHOC/TimeZonePanelButtonHOC';
import {
    BoardEmailPanelButtonHOC
} from '../../../details/Email/hocs/BoardEmailPanelButtonHOC/BoardEmailPanelButtonHOC';
import { ArchiveButtonHOC } from '../../../actions/hocs/ArchiveButtonHOC/ArchiveButtonHOC';
import { UnarchiveButtonHOC } from '../../../actions/hocs/UnarchiveButtonHOC/UnarchiveButtonHOC';
import {
    StatusListsPanelButtonHOC
} from '../../../details/StatusLists/hocs/StatusListsPanelButtonHOC/StatusListsPanelButtonHOC';
import {
    ArchiveOnDeletePanelButtonHOC
} from '../../../details/ArchiveOnDelete/hocs/ArchiveOnDeletePanelButtonHOC/ArchiveOnDeletePanelButtonHOC';
import {
    CardPropertiesPanelButtonHOC
} from '../../../details/CardProperties/hocs/CardPropertiesPanelButtonHOC/CardPropertiesPanelButtonHOC';
import { OpenInDriveButtonHOC } from '../../../actions/hocs/OpenInDriveButtonHOC/OpenInDriveButtonHOC';
import {
    CustomPropertiesPanelButtonHOC
} from '../../../details/CardCustomProperties/hocs/CustomPropertiesPanelButtonHOC/CustomPropertiesPanelButtonHOC';
import { RolesPanelButtonHOC } from '../../../details/Roles/hocs/RolesPanelButtonHOC/RolesPanelButtonHOC';
import {
    EstimateTimePanelButtonHOC
} from '../../../details/EstimateTime/hocs/EstimateTimePanelButtonHOC/EstimateTimePanelButtonHOC';
import { TagsPanelButtonHOC } from '../../../details/Tags/hocs/TagsPanelButtonHOC/TagsPanelButtonHOC';
import {
    CLASS_ASIDE_PANEL_ACTIONS_SECTION_ADD_PROPERTIES,
    CLASS_ASIDE_PANEL_ACTIONS_SECTION_CONTAINER
} from '../../../../asidePanel/components/AsidePanelActionsSection/constants';
import {
    PwcImportPanelButtonHOC
} from '../../../details/PwcImport/hocs/PwcImportPanelButtonHOC/PwcImportPanelButtonHOC';
import {
    BoardImportPanelButtonHOC
} from '../../../details/ImportBoard/hocs/BoardImportPanelButtonHOC/BoardImportPanelButtonHOC';
import { DatesPanelButtonHOC } from '../../../details/Dates/hocs/DatesPanelButtonHOC/DatesPanelButtonHOC';
import {
    CardAgingPanelButtonHOC
} from '../../../details/CardAging/hocs/CardAgingPanelButtonHOC/CardAgingPanelButtonHOC';
import {
    BOARD_ACTIONS_AUTOMATION,
    BOARD_ACTIONS_CARD,
    BOARD_ACTIONS_NOTIFICATIONS,
    BOARD_ACTIONS_OTHER
} from './constants';
import { InfoPanelButtonHOC } from '../../../details/Info/hocs/InfoPanelButtonHOC/InfoPanelButtonHOC';
import { WebhooksPanelButtonHOC } from '../../../details/Webhooks/hocs/WebhooksPanelButtonHOC/WebhooksPanelButtonHOC';
import { MoveToPanelButtonHOC } from '../../../details/MoveTo/hocs/MoveToPanelButtonHOC/MoveToPanelButtonHOC';
import { CopyPanelButtonHOC } from '../../../details/Copy/hocs/CopyPanelButtonHOC/CopyPanelButtonHOC';
import { TemplatePanelButtonHOC } from '../../../details/Template/hocs/TemplatePanelButtonHOC/TemplatePanelButtonHOC';
import { ChatsPanelButtonHOC } from '../../../details/Chats/hocs/ChatsPanelButtonHOC/ChatsPanelButtonHOC';

export function PanelActions({
    boardId,
    isShow,
}: IPanelActionsProps) {
    if (!isShow) {
        return null;
    }

    const { changeTab } = React.useContext(AsidePanelContext);
    const onClickSwitchTabDetails = () => changeTab(EBoardTab.DETAILS);

    return (
        <>
            <AsidePanelActionsSection
                title={ASIDE_PANEL_ACTIONS_SECTION_TITLE_SETTINGS}
                onClick={() => {
                    const el = document.querySelector('.' + CLASS_ASIDE_PANEL_ACTIONS_SCROLL) as HTMLElement;
                    if (el) {
                        el.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                }}
            >
                <div className={CLASS_ASIDE_PANEL_ACTIONS_SECTION_CONTAINER}>
                    <div className={CLASS_ASIDE_PANEL_ACTIONS_SECTION_ADD_PROPERTIES}>
                        <AsidePanelActionsButtonsGroup>
                            <InfoPanelButtonHOC onClick={onClickSwitchTabDetails}/>
                        </AsidePanelActionsButtonsGroup>

                        <AsidePanelActionsButtonsGroup title={BOARD_ACTIONS_NOTIFICATIONS}>
                            <EmailNotificationsPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                            <PushNotificationsPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                            <ChatsPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                        </AsidePanelActionsButtonsGroup>

                        <AsidePanelActionsButtonsGroup title={BOARD_ACTIONS_CARD}>
                            <PrefixesPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                            <CardPropertiesPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                            <CustomPropertiesPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                            <ColorsPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                            <TagsPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                            <RolesPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                            <DatesPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                        </AsidePanelActionsButtonsGroup>

                        <AsidePanelActionsButtonsGroup title={BOARD_ACTIONS_AUTOMATION}>
                            <CardAgingPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                            <GanttPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                            <ArchiveOnDeletePanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                            <StatusListsPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                            <EstimateTimePanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                            <WebhooksPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                        </AsidePanelActionsButtonsGroup>

                        <AsidePanelActionsButtonsGroup title={BOARD_ACTIONS_OTHER}>
                            <LinksToCardsPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                            <TimeZonePanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                            <BoardEmailPanelButtonHOC
                                boardId={boardId}
                                onClick={onClickSwitchTabDetails}
                            />
                        </AsidePanelActionsButtonsGroup>
                    </div>
                </div>
            </AsidePanelActionsSection>
            <AsidePanelActionsSection
                titleClassName={'aside-panel__actions-section-title--board-actions'}
                title={ASIDE_PANEL_ACTIONS_SECTION_TITLE_ACTIONS}
                onClick={() => {
                    const el = document.querySelector('.' + CLASS_ASIDE_PANEL_ACTIONS_SCROLL) as HTMLElement;
                    if (el) {
                        el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
                    }
                }}
            >
                <div className={CLASS_ASIDE_PANEL_ACTIONS_SECTION_CONTAINER}>
                    <div className={CLASS_ASIDE_PANEL_ACTIONS_SECTION_ADD_PROPERTIES}>
                        <AsidePanelActionsButtonsGroup>
                            <MoveToPanelButtonHOC
                                boardId={boardId}
                            />
                            <PwcImportPanelButtonHOC
                                boardId={boardId}
                            />
                            <BoardImportPanelButtonHOC
                                boardId={boardId}
                            />
                            <CopyPanelButtonHOC
                                boardId={boardId}
                            />
                            <TemplatePanelButtonHOC
                                boardId={boardId}
                            />
                            <OpenInDriveButtonHOC
                                boardId={boardId}
                            />
                        </AsidePanelActionsButtonsGroup>

                        <AsidePanelActionsButtonsGroup>
                            <ArchiveButtonHOC
                                boardId={boardId}
                            />
                            <UnarchiveButtonHOC
                                boardId={boardId}
                            />
                            <DeleteButtonHOC
                                boardId={boardId}
                            />
                        </AsidePanelActionsButtonsGroup>
                    </div>
                </div>
            </AsidePanelActionsSection>
        </>
);
}
